/**
 * Raises `useV2Ui.chromeHidden` while a BOARD is on screen and lowers it the
 * moment it is not — called once from `index.tsx`, the screen root, the same
 * way `useUnmountCleanup` is. `navigators/Application` reads the flag; the
 * OLD lane never raises it, so a lane flip restores the shell's own header.
 *
 * D8 REVISED 2026-10-06 (fix F-B / F1): the original decision raised the flag
 * for the screen's WHOLE mount, lobby included — the owner changed the rule
 * once the header started visibly stealing board height on the pre-game
 * pages too. Now it tracks `!isPageState(railState)`: the lobby, the seeking /
 * challenge-out pages and the tournament PAGE (none of them have a board)
 * keep the shell header; a live game, an ended game with its result, a watch
 * and a tournament PAIRING (which switches `railState` to a stage state) hide
 * it — `chrome/pageStates.ts` is the ONE definition of "a board is up" that
 * `Body.tsx` and this hook both read, so they cannot disagree.
 */
import {useEffect} from 'react';

import {selectRailState} from '@/Store/liveGame/selectors';
import {useLiveGame} from '@/Store/liveGameStore';

import {isPageState} from './pageStates';
import {useV2Ui} from '../theme/useV2Ui';

export function useChromeHidden(): void {
  const boardOnScreen = useLiveGame(s => !isPageState(selectRailState(s)));

  useEffect(() => {
    useV2Ui.getState().setChromeHidden(boardOnScreen);
    return () => {
      useV2Ui.getState().setChromeHidden(false);
    };
  }, [boardOnScreen]);
}

export default useChromeHidden;
